import Particle from 'asteroids-shared/entities/Particle';
import { randomNumBetween, rotatePoint } from 'asteroids-shared/helpers';

/**
 * Cosmetic-only particle manager. Lives entirely on the client; the server
 * never sees particles. Spawned in response to destroy_asteroid / ship_hit
 * events and from the local ship's own thrust.
 */
export default class ClientParticles {
  constructor() { /** @type {Particle[]} */ this.list = []; }

  update(dt) {
    for (let i = this.list.length - 1; i >= 0; i--) {
      this.list[i].update(dt);
      if (this.list[i].dead) this.list.splice(i, 1);
    }
  }

  spawnAsteroidBurst(x, y, radius) {
    const n = Math.round(radius);
    for (let i = 0; i < n; i++) {
      this.list.push(new Particle({
        lifeSpan: randomNumBetween(60, 100),
        size: randomNumBetween(1, 3),
        position: { x: x + randomNumBetween(-radius / 4, radius / 4), y: y + randomNumBetween(-radius / 4, radius / 4) },
        velocity: { x: randomNumBetween(-1.5, 1.5), y: randomNumBetween(-1.5, 1.5) }
      }));
    }
  }

  spawnShipExplosion(x, y) {
    for (let i = 0; i < 60; i++) {
      this.list.push(new Particle({
        lifeSpan: randomNumBetween(60, 100),
        size: randomNumBetween(1, 4),
        position: { x: x + randomNumBetween(-5, 5), y: y + randomNumBetween(-5, 5) },
        velocity: { x: randomNumBetween(-1.5, 1.5), y: randomNumBetween(-1.5, 1.5) }
      }));
    }
  }

  spawnShieldFlash(x, y) {
    for (let i = 0; i < 12; i++) {
      const angle = (i / 12) * Math.PI * 2 + randomNumBetween(-0.1, 0.1)
      const speed = randomNumBetween(1.2, 2.2)
      this.list.push(new Particle({
        lifeSpan: randomNumBetween(14, 22),
        size: randomNumBetween(1, 2),
        position: { x, y },
        velocity: { x: Math.cos(angle) * speed, y: Math.sin(angle) * speed }
      }))
    }
  }

  spawnThruster(ship) {
    const offset = rotatePoint({ x: 0, y: -10 }, { x: 0, y: 0 }, (ship.rotation - 180) * Math.PI / 180);
    this.list.push(new Particle({
      lifeSpan: randomNumBetween(20, 40),
      size: randomNumBetween(1, 3),
      position: {
        x: ship.position.x + offset.x + randomNumBetween(-2, 2),
        y: ship.position.y + offset.y + randomNumBetween(-2, 2)
      },
      velocity: {
        x: offset.x / randomNumBetween(3, 5),
        y: offset.y / randomNumBetween(3, 5)
      }
    }));
  }
}
